export default __webpack_public_path__ + "media/images/backgrounds/bg-10-bb4be80df65f11a547c3db7037cc4ed0.jpg";